import React, { useState } from 'react'
import { Popover } from '@mui/material'

interface Props {
  /** How many filters are set — shown as a badge so a hidden filter can't be forgotten. */
  activeCount: number
  children: React.ReactNode
  onClear?: () => void
}

/**
 * Sort, direction and type filters all live behind this one control, so a list
 * page's view controls stop being scattered across three different places.
 */
export const PageBarFilters = ({ activeCount, children, onClear }: Props) => {
  const [anchor, setAnchor] = useState<HTMLElement | null>(null)

  return (
    <>
      <button
        type="button"
        onClick={e => setAnchor(e.currentTarget)}
        className={`flex h-9 flex-shrink-0 items-center gap-2 rounded-lg border px-3 text-sm font-medium transition-colors ${
          activeCount > 0
            ? 'border-mm-primary-500 text-mm-primary-700'
            : 'border-mm-neutral-1-300 text-mm-neutral-1-700 hover:bg-mm-neutral-1-50'
        }`}
      >
        <i className="fad fa-filter text-xs" aria-hidden />
        Filters
        {activeCount > 0 && (
          <span className="rounded-full bg-mm-primary-500 px-1.5 text-xxs font-semibold text-white">
            {activeCount}
          </span>
        )}
      </button>

      <Popover
        open={Boolean(anchor)}
        anchorEl={anchor}
        onClose={() => setAnchor(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      >
        <div className="w-80 space-y-4 p-4">
          {children}
          {onClear && activeCount > 0 && (
            <button
              type="button"
              onClick={onClear}
              className="text-xs font-medium text-mm-neutral-1-600 underline hover:text-mm-neutral-1-900"
            >
              Clear filters
            </button>
          )}
        </div>
      </Popover>
    </>
  )
}
